import axios from 'axios'
import formatSbPath from '~/utils/formatSbPath'

const resolveRelations = [
  'vacancy-page.representative',
  'vacancy-page.disclaimer',
  'benefits.benefits',
  'Teams.content'
]

// TODO: Move this to server side

export default class StoryBlok {
  static async pullStories() {
    const config = useRuntimeConfig()
    const version = config.public.env === 'production' ? 'published' : 'draft'
    const pageSize = 10
    let page = 1
    const url = `https://api.storyblok.com/v2/cdn/stories/?version=${version}&token=${config.public.storyblokToken}&per_page=${pageSize}&page=${page}&starts_with=careers&excluding_slugs=careers/data*`

    const response = await axios.get(url)

    const result: any = []

    if (response.status === 200) {
      result.push(...response.data.stories)
    }

    const pageCount = Math.ceil(response.headers.total / pageSize)

    if (pageCount > 1) {
      for (page = 2; page <= pageCount; page++) {
        const url = `https://api.storyblok.com/v2/cdn/stories/?version=${version}&token=${config.public.storyblokToken}&per_page=${pageSize}&page=${page}&starts_with=careers&excluding_slugs=careers/data*`

        const response = await axios.get(url)

        if (response.status === 200) {
          result.push(...response.data.stories)
        }
      }
    }

    return result
  }

  static async pullVacancies(lang: string) {
    const config = useRuntimeConfig()
    const version = config.public.env === 'production' ? 'published' : 'draft'
    const pageSize = 100
    let page = 1
    const locale = lang === 'en' ? '' : `${lang}/`

    const url = `https://api.storyblok.com/v2/cdn/stories/?version=${version}&token=${config.public.storyblokToken}&per_page=${pageSize}&page=${page}&starts_with=${locale}careers/vacancies&&excluding_slugs=careers/vacancies/`

    const response = await axios.get(url)

    const result: any = []

    if (response.status === 200) {
      result.push(...this.#parseVacancies(response.data.stories, lang))
    }

    const pageCount = Math.ceil(response.headers.total / pageSize)

    if (pageCount > 1) {
      for (page = 2; page <= pageCount; page++) {
        const url = `https://api.storyblok.com/v2/cdn/stories/?version=${version}&token=${config.public.storyblokToken}&per_page=${pageSize}&page=${page}&starts_with=${locale}careers/vacancies&excluding_slugs=careers/vacancies/`

        const response = await axios.get(url)

        if (response.status === 200) {
          result.push(...this.#parseVacancies(response.data.stories, lang))
        }
      }
    }

    return result
  }

  static async pull(path: string) {
    const { locale } = useI18n()
    const config = useRuntimeConfig()
    const version = config.public.env === 'production' ? 'published' : 'draft'

    const apiConfig: any = {
      version,
      language: locale.value,
      resolve_links: 'story',
      resolve_relations: resolveRelations.join(',')
    }

    return await useAsyncStoryblok(`careers/${path}`, apiConfig)
      .then((response) => response.value)
      .catch((error) => {
        throw showError({ statusCode: error.status, fatal: true, message: 'Issue loading the data' })
      })
  }

  static #parseVacancies(vacancies: any, lang: string) {
    const results: any = []

    vacancies.forEach((story: any) => {
      if (lang === 'en') {
        results.push({ path: formatSbPath(story.full_slug, lang), title: story.name })
      } else {
        const tSlug = story.translated_slugs.find((slug: any) => slug.lang === lang)

        results.push({ path: formatSbPath(tSlug.path, lang), title: tSlug.name })
      }
    })

    return results
  }
}
